import React from 'react';
import SignatureCanvas from '../../components/SignatureCanvas';

import { Icon, Button } from 'semantic-ui-react';
import './style.css';

export const SignatureArea = ({
  isSigned,
  loading,
  buttonStyle = {},
  handleSave,
  handleClear,
  refSignaturePad,
}) => {
  return (
    <div className='signature-area'>
      <SignatureCanvas
        canvasProps={{ className: 'sigCanvas' }}
        ref={refSignaturePad}
        clearOnResize={false}
      />
      <div className='button-container'>
        <Button
          className='uploadbtn'
          primary
          data-testid='save-signature-button'
          onClick={handleSave}
          loading={loading}
          style={{
            background: isSigned ? '#42ca49' : buttonStyle.background,
            color: buttonStyle.color,
          }}
          icon={
            !loading && (
              <Icon
                name={isSigned ? 'check' : 'save'}
                color={buttonStyle.color}
              />
            )
          }
          content={isSigned ? 'Saved' : 'Save'}
        />
        <Button
          className='uploadbtn delete-button'
          primary
          data-testid='clear-signature-button'
          onClick={handleClear}
          icon={<Icon name='delete' style={{ color: 'white' }} />}
          content='Clear'
        />
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/SignatureArea/index.jsx